import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { MomentModule } from 'angular2-moment';
import { ModalModule } from 'ngx-bootstrap/modal';

import { SharedCommonService } from "app/shared/shared-common.service";
import { FooterComponent } from './footer/footer.component';
import { QuickActionMessagesComponent } from './components/quick-action-messages.component';
import { BusyLoaderService } from './components/busy-loader.service';
import { BusyLoaderComponent } from './components/busy-loader.component';

export { Allergy } from "./allergy";
export { Annotation } from "./annotation";
export { AtmistData, ATMISTSigns } from "./AtmistData";
export { Client } from './client';
export { Doctor } from "./doctor";
export { Incident } from "./incident";
export { IncidentAdvice } from "./incident-advice";
export { IncidentDetail } from "./incident-detail";
export { IncidentFinding } from "./incident-finding";
export { MedicalHistory } from "./medical-history";
export { Medication } from "./medication";
export { Observation } from "./observation";
export { Person } from "./person";
export { User } from './user';

export { Contact } from "./contact";
export { SlimScrollOptions, Variables } from "./variables";

const AppRoutes: Routes = [
	//{ path: '**', component: PageNotFoundComponent }
];

@NgModule({
	imports: [
		CommonModule,
		MomentModule,
        ModalModule,
		RouterModule.forRoot(
			AppRoutes,
			{ enableTracing: true } // <-- debugging purposes only
		)
	],
    declarations: [FooterComponent, QuickActionMessagesComponent, BusyLoaderComponent],
    providers: [SharedCommonService, BusyLoaderService],
    exports: [FooterComponent, QuickActionMessagesComponent, BusyLoaderComponent]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts